import Script from 'next/script'

export default function GoogleAnalytics() {
  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=G-8BE554Q4R8`} strategy="lazyOnload" />
      <Script id="google-analytics" strategy="lazyOnload">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-8BE554Q4R8', {
                page_path: window.location.pathname,
            });
        `}
      </Script>
    </>
  )
}
